import { createFileRoute } from '@tanstack/react-router';
import { Spinner } from '@repo/components';

export const Route = createFileRoute('/personal_/groups/$groupId/')({
	component: GroupDetailIndex,
});

function GroupDetailIndex() {
	return (
		<div className="flex items-center justify-center p-8">
			<Spinner />
		</div>
	);
}
